<template>
    <v-container fluid class="page-container">
        <page-header title="Vouchers" :subtitle="totalLabel">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New voucher
            </v-btn>
        </page-header>

        <filter-panel
            :fields="filterFields"
            :value="listState"
            :loading="loading"
            @apply="applyFilters"
        />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No vouchers yet"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.team`]="{ item }">{{ item.team ? item.team.title : '—' }}</template>
                <template v-slot:[`item.member`]="{ item }">
                    <span class="font-weight-medium">{{ memberName(item.member) }}</span>
                </template>
                <template v-slot:[`item.description`]="{ item }">
                    <div class="description">{{ item.description }}</div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button title="Delete this voucher?" @delete-entry="deleteItem(item, deleteVoucher, 'Voucher')" />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import voucherService from '@/services/voucher-service'
    import teamService from '@/services/team-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'
    import { fullName } from '@/utils/format'

    export default {
        name: 'VoucherRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                teams: null,
                headers: [
                    { text: 'Member', value: 'member' },
                    { text: 'Team', value: 'team' },
                    { text: 'Description', value: 'description' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        computed: {
            filterFields() {
                return [
                    { key: 'team', label: 'Team', type: 'autocomplete', items: this.teams, itemText: 'title' }
                ]
            }
        },
        created() {
            teamService.getTeamOptions().then(resp => {
                this.teams = resp.data.data
            }).catch(() => {
                this.teams = []
            })
        },
        methods: {
            fetchPage({ page, perPage, filters }) {
                return voucherService.getVouchersByFilter(page, filters, perPage)
            },
            deleteVoucher: id => voucherService.deleteVoucherById(id),
            memberName(member) {
                return member && typeof member === 'object' ? fullName(member) : '—'
            }
        }
    }
</script>

<style scoped>
.description {
    max-width: 480px;
    white-space: normal;
}
</style>
